import { IconClose } from '@consta/icons/IconClose'
import { Button } from '@consta/uikit/Button'
import { Text } from '@consta/uikit/Text'
import { Show } from '@library/components'
import cn from 'classnames'
import type { FC, PropsWithChildren } from 'react'

import css from './ModalButton.css'

type ModalHeaderProps = {
  title: string
  handleClose: VoidFunction
  expanded: boolean
  handleOpen: VoidFunction
}

export const ModalHeader: FC<PropsWithChildren<ModalHeaderProps>> = ({
  title,
  children,
  handleClose,
  expanded,
  handleOpen,
}) => {
  return (
    <header
      className={cn(css.header, { [css.expanded]: expanded })}
      onClick={expanded ? undefined : handleOpen}>
      <Text size="s" view={expanded ? 'primary' : 'secondary'}>
        {title}
      </Text>
      <Show when={expanded}>
        {children}
        <Button
          className={css.closeButton}
          label={`Закрыть ${title.toLowerCase()}`}
          onlyIcon={true}
          iconLeft={IconClose}
          size="xs"
          view="clear"
          onClick={handleClose}
        />
      </Show>
    </header>
  )
}
